
// import React, { useEffect, useState } from "react";

// const ReimbursementManagement = () => {

//   const [requests, setRequests] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fileBaseUrl = "/gt-api/uploads/reimbursements/";

//   const fetchRequests = async () => {
//     try {

//       const res = await fetch("/gt-api/get_all_reimbursements.php");
//       const data = await res.json();

//       if (data.success) {
//         setRequests(data.requests);
//       }

//     } catch (error) {
//       console.error("Fetch Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchRequests();

//     const interval = setInterval(fetchRequests, 5000);

//     return () => clearInterval(interval);

//   }, []);

//   const handleStatusUpdate = async (id, status) => {

//     try {

//       const response = await fetch("/gt-api/update_reimbursement_status.php", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           id,
//           status
//         })
//       });

//       const result = await response.json();

//       if (result.success) {

//         setRequests(prev =>
//           prev.map(req =>
//             req.id === id ? { ...req, status } : req
//           )
//         );

//         alert(`Request ${status}`);

//       }

//     } catch (error) {
//       console.error("Update error:", error);
//     }
//   };

//   const pending = requests.filter(r => r.status?.toLowerCase() === "pending");
//   const history = requests.filter(r => r.status?.toLowerCase() !== "pending");

//   return (
//     <div className="management-request-wrapper animate-fade" style={{ padding: "20px" }}>

//       {/* PENDING REQUESTS */}

//       <div className="module-glass-card" style={{ marginBottom: "30px" }}>

//         <h3 className="cyan-text">💰 REIMBURSEMENT_REQUESTS ({pending.length})</h3>

//         <div className="admin-table-container">

//           {/* <table className="cyber-table"> */}
//           <table
//             className="cyber-table"
//             style={{ tableLayout: "fixed", width: "100%" }}
//           >

//             {/* <thead>
//               <tr>
//                 <th>EMPLOYEE</th>
//                 <th>CATEGORY</th>
//                 <th>DESCRIPTION</th>
//                 <th>AMOUNT</th>
//                 <th>DATE</th>
//                 <th>RECEIPT</th>
//                 <th>ACTION</th>
//               </tr>
//             </thead> */}
//             <tr>
//               {/* Left aligned fields */}
//               <th style={{ width: '150px', textAlign: 'left', padding: '12px' }}>
//                 EMPLOYEE
//               </th>

//               <th style={{ width: '200px', textAlign: 'left', padding: '12px' }}>
//                 CATEGORY
//               </th>

//               <th style={{ width: '480px', textAlign: 'left', padding: '12px' }}>
//                 DESCRIPTION
//               </th>

//               {/* Compact fields */}
//               <th style={{ width: '130px', textAlign: 'left', padding: '12px' }}>
//                 AMOUNT
//               </th>

//               <th style={{ width: '90px', textAlign: 'left', padding: '12px' }}>
//                 DATE
//               </th>

//               {/* Center aligned */}
//               <th style={{ width: '120px', textAlign: 'center', padding: '12px' }}>
//                 RECEIPT
//               </th>

//               <th style={{ width: '120px', textAlign: 'center', padding: '12px' }}>
//                 ACTION
//               </th>
//             </tr>

//             <tbody>

//               {loading ? (
//                 <tr>
//                   <td colSpan="7">Loading requests...</td>
//                 </tr>
//               ) : pending.length > 0 ? (

//                 pending.map(req => (

//                   <tr key={req.id}>

//                     <td style={{ width: '200px', padding: '12px' }}>
//                       {req.employee_name}
//                     </td>

//                     <td style={{ width: '150px', padding: '12px' }}>
//                       {req.category}
//                     </td>

//                     <td
//                       style={{
//                         width: '300px',
//                         padding: '12px',
//                         whiteSpace: 'normal',
//                         wordBreak: 'break-word'
//                       }}
//                     >
//                       {req.item_name}
//                     </td>

//                     <td style={{ width: '120px', padding: '12px' }}>
//                       ₹ {req.amount}
//                     </td>

//                     <td style={{ width: '140px', padding: '12px' }}>
//                       {req.expense_date}
//                     </td>

//                     <td style={{ width: '120px', padding: '12px', textAlign: 'center' }}>
//                       <a
//                         href={fileBaseUrl + req.receipt_file}
//                         target="_blank"
//                         rel="noreferrer"
//                         className="table-action-btn view"
//                       >
//                         VIEW
//                       </a>
//                     </td>

//                     <td style={{ width: '120px', padding: '12px', textAlign: 'center'  }}>
//                       <button
//                         className="mgnt-btn approve"
//                         onClick={() => handleStatusUpdate(req.id, "Approved")}
//                         style={{ marginRight: '6px' , backgroundColor:'#06aa14'}}
//                       >
//                         ✔
//                       </button>

//                       <button
//                         className="mgnt-btn reject"
//                         onClick={() => handleStatusUpdate(req.id, "Rejected")}
//                         style={{ marginRight: '6px' , backgroundColor:'#f04343'}}
//                       >
//                         ✖
//                       </button>
//                     </td>

//                   </tr>
//                 ))

//               ) : (

//                 <tr>
//                   <td colSpan="7">NO_PENDING_REQUESTS</td>
//                 </tr>

//               )}

//             </tbody>

//           </table>

//         </div>

//       </div>

//       {/* HISTORY */}

//       <div className="module-glass-card history-card" style={{ opacity: 0.9 }}>

//         <h3 style={{ color: "#888" }}>📜 PROCESSED_HISTORY ({history.length})</h3>

//         <div className="admin-table-container">

//           <table className="cyber-table">


//             {/* <thead>
//               <tr>
//                 <th>EMPLOYEE</th>
//                 <th>CATEGORY</th>
//                 <th>AMOUNT</th>
//                 <th>DATE</th>
//                 <th>RECEIPT</th>
//                 <th>STATUS</th>
//               </tr>
//             </thead> */}

//             <thead style={{ background: "#111827", borderBottom: "1px solid #374151" }}>
//               <tr>
//                 <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
//                   EMPLOYEE
//                 </th>

//                 <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
//                   CATEGORY
//                 </th>

//                 <th style={{ padding: "12px", width: "13%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
//                   AMOUNT
//                 </th>

//                 <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
//                   DATE
//                 </th>

//                 <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
//                   RECEIPT
//                 </th>

//                 <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
//                   STATUS
//                 </th>
//               </tr>
//             </thead>
//             <tbody>

//               {history.length > 0 ? (

//                 history.map(req => (
//                   <tr key={req.id}>

//                     <td>{req.employee_name}</td>

//                     <td>{req.category}</td>

//                     <td>₹ {req.amount}</td>

//                     <td style={{ width: "15%", padding: "12px" }}>
//                       {req.expense_date}
//                     </td>


//                     {/* ✅ ADD THIS BLOCK */}
//                     <td style={{ width: "15%", padding: "12px" }}>
//                       {req.receipt_file ? (
//                         <a
//                           href={fileBaseUrl + req.receipt_file}
//                           target="_blank"
//                           rel="noreferrer"
//                           className="table-action-btn view"
//                         >
//                           VIEW
//                         </a>
//                       ) : (
//                         "No File"
//                       )}
//                     </td>

//                     <td>
//                       <span
//                         className={`status-text-${req.status?.toLowerCase()}`}
//                         style={{ fontWeight: "bold" }}
//                       >
//                         {req.status?.toUpperCase()}
//                       </span>
//                     </td>

//                   </tr>
//                 ))

//               ) : (

//                 <tr>
//                   <td colSpan="6">NO_HISTORY_FOUND</td>
//                 </tr>

//               )}

//             </tbody>

//           </table>

//         </div>

//       </div>

//     </div>
//   );
// };

// export default ReimbursementManagement;
























// import React, { useEffect, useState } from "react";
// import '../styles/ReimbursementManagement.css';

// const ReimbursementManagement = () => {

//   const [requests, setRequests] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fileBaseUrl = "/gt-api/uploads/reimbursements/";

//   const fetchRequests = async () => {
//     try {

//      const res = await fetch(
//   "/gt-api/get_all_reimbursements.php",
//   {
//     credentials: "include"
//   }
// );
//       const data = await res.json();

//       if (data.success) {
//         setRequests(data.requests);
//       }

//     } catch (error) {
//       console.error("Fetch Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchRequests();

//     const interval = setInterval(fetchRequests, 5000);

//     return () => clearInterval(interval);

//   }, []);

//   const handleStatusUpdate = async (id, status) => {

//     try {

//       const response = await fetch("/gt-api/update_reimbursement_status.php", {
//         method: "POST",
//         credentials: "include",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           id,
//           status
//         })
//       });

//       const result = await response.json();

//       if (result.success) {

//         setRequests(prev =>
//           prev.map(req =>
//             req.id === id ? { ...req, status } : req
//           )
//         );

//         alert(`Request ${status}`);

//       }

//     } catch (error) {
//       console.error("Update error:", error);
//     }
//   };

//   const pending = requests.filter(r => r.status?.toLowerCase() === "pending");
//   const history = requests.filter(r => r.status?.toLowerCase() !== "pending");

//   return (
//     <div className="management-request-wrapper animate-fade" style={{ padding: "20px" }}>

//       {/* PENDING REQUESTS */}

//       <div className="module-glass-card" style={{ marginBottom: "30px" }}>

//         <h3 className="cyan-text">💰 REIMBURSEMENT_REQUESTS ({pending.length})</h3>

//         <div className="admin-table-container reimbursement-table-wrapper">

//   <table
//     className="cyber-table reimbursement-table"
//     style={{ tableLayout: "fixed", width: "100%" }}
//   >

//             <tr>
//               {/* Left aligned fields */}
//               <th style={{ width: '150px', textAlign: 'left', padding: '12px' }}>
//                 EMPLOYEE
//               </th>

//               <th style={{ width: '200px', textAlign: 'left', padding: '12px' }}>
//                 CATEGORY
//               </th>

//               <th style={{ width: '480px', textAlign: 'left', padding: '12px' }}>
//                 DESCRIPTION
//               </th>

//               {/* Compact fields */}
//               <th style={{ width: '130px', textAlign: 'left', padding: '12px' }}>
//                 AMOUNT
//               </th>

//               <th style={{ width: '90px', textAlign: 'left', padding: '12px' }}>
//                 DATE
//               </th>

//               {/* Center aligned */}
//               <th style={{ width: '120px', textAlign: 'center', padding: '12px' }}>
//                 RECEIPT
//               </th>

//               <th style={{ width: '120px', textAlign: 'center', padding: '12px' }}>
//                 ACTION
//               </th>
//             </tr>

//             <tbody>

//               {loading ? (
//                 <tr>
//                   <td colSpan="7">Loading requests...</td>
//                 </tr>
//               ) : pending.length > 0 ? (

//                 pending.map(req => (

//                   <tr key={req.id}>

//                     <td style={{ width: '200px', padding: '12px' }}>
//                       {req.employee_name}
//                     </td>

//                     <td style={{ width: '150px', padding: '12px' }}>
//                       {req.category}
//                     </td>

//                     <td
//                       style={{
//                         width: '300px',
//                         padding: '12px',
//                         whiteSpace: 'normal',
//                         wordBreak: 'break-word'
//                       }}
//                     >
//                       {req.item_name}
//                     </td>

//                     <td style={{ width: '120px', padding: '12px' }}>
//                       ₹ {req.amount}
//                     </td>

//                     <td style={{ width: '140px', padding: '12px' }}>
//                       {req.expense_date}
//                     </td>

//                     <td style={{ width: '120px', padding: '12px', textAlign: 'center' }}>
//                       <a
//                         href={fileBaseUrl + req.receipt_file}
//                         target="_blank"
//                         rel="noreferrer"
//                         className="table-action-btn view"
//                       >
//                         VIEW
//                       </a>
//                     </td>

//                     <td style={{ width: '120px', padding: '12px', textAlign: 'center'  }}>
//                       <button
//                         className="mgnt-btn approve"
//                         onClick={() => handleStatusUpdate(req.id, "Approved")}
//                         style={{ marginRight: '6px' , backgroundColor:'#06aa14'}}
//                       >
//                         ✔
//                       </button>

//                       <button
//                         className="mgnt-btn reject"
//                         onClick={() => handleStatusUpdate(req.id, "Rejected")}
//                         style={{ marginRight: '6px' , backgroundColor:'#f04343'}}
//                       >
//                         ✖
//                       </button>
//                     </td>

//                   </tr>
//                 ))

//               ) : (

//                 <tr>
//                   <td colSpan="7">NO_PENDING_REQUESTS</td>
//                 </tr>

//               )}

//             </tbody>

//           </table>

//         </div>

//       </div>

//       {/* HISTORY */}

//       <div className="module-glass-card history-card" style={{ opacity: 0.9 }}>

//         <h3 style={{ color: "#888" }}>📜 PROCESSED_HISTORY ({history.length})</h3>

//         <div className="admin-table-container">

//           <table className="cyber-table">




//             <thead style={{ background: "#111827", borderBottom: "1px solid #374151" }}>
//               <tr>
//                 <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
//                   EMPLOYEE
//                 </th>

//                 <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
//                   CATEGORY
//                 </th>

//                 <th style={{ padding: "12px", width: "13%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
//                   AMOUNT
//                 </th>

//                 <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
//                   DATE
//                 </th>

//                 <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
//                   RECEIPT
//                 </th>

//                 <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
//                   STATUS
//                 </th>
//               </tr>
//             </thead>
//             <tbody>

//               {history.length > 0 ? (

//                 history.map(req => (
//                   <tr key={req.id}>

//                     <td>{req.employee_name}</td>

//                     <td>{req.category}</td>

//                     <td>₹ {req.amount}</td>

//                     <td style={{ width: "15%", padding: "12px" }}>
//                       {req.expense_date}
//                     </td>


//                     {/* ✅ ADD THIS BLOCK */}
//                     <td style={{ width: "15%", padding: "12px" }}>
//                       {req.receipt_file ? (
//                         <a
//                           href={fileBaseUrl + req.receipt_file}
//                           target="_blank"
//                           rel="noreferrer"
//                           className="table-action-btn view"
//                         >
//                           VIEW
//                         </a>
//                       ) : (
//                         "No File"
//                       )}
//                     </td>

//                     <td>
//                       <span
//                         className={`status-text-${req.status?.toLowerCase()}`}
//                         style={{ fontWeight: "bold" }}
//                       >
//                         {req.status?.toUpperCase()}
//                       </span>
//                     </td>

//                   </tr>
//                 ))

//               ) : (

//                 <tr>
//                   <td colSpan="6">NO_HISTORY_FOUND</td>
//                 </tr>

//               )}

//             </tbody>

//           </table>

//         </div>

//       </div>

//     </div>
//   );
// };

// export default ReimbursementManagement;


















import React, { useEffect, useState } from "react";
import '../styles/ReimbursementManagement.css';

const ReimbursementManagement = () => {

  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const fileBaseUrl = "/gt-api/uploads/reimbursements/";

  const fetchRequests = async () => {
    try {

      const res = await fetch(
        "/gt-api/get_all_reimbursements.php",
        {
          credentials: "include"
        }
      );
      const data = await res.json();

      if (data.success) {
        setRequests(data.requests);
      }

    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();

    const interval = setInterval(fetchRequests, 5000);

    return () => clearInterval(interval);

  }, []);

  const handleStatusUpdate = async (id, status) => {

    try {

      const response = await fetch("/gt-api/update_reimbursement_status.php", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id,
          status
        })
      });

      const result = await response.json();

      if (result.success) {

        setRequests(prev =>
          prev.map(req =>
            req.id === id ? { ...req, status } : req
          )
        );

        alert(`Request ${status}`);

      }

    } catch (error) {
      console.error("Update error:", error);
    }
  };

  const pending = requests.filter(r => r.status?.toLowerCase() === "pending");
  const history = requests.filter(r => r.status?.toLowerCase() !== "pending");

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this reimbursement record?"
    );

    if (!confirmDelete) return;

    const password = window.prompt(
      "Enter your Password or Master Password to confirm deletion:"
    );

    if (!password) return;

    try {
      const response = await fetch(
        "/gt-api/delete_reimbursement.php",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id,
            password,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        fetchRequests();
        alert("Record deleted successfully");
      } else {
        alert(data.message || "Invalid Password");
      }
    } catch (error) {
      console.error("Delete Error:", error);
      alert("Server error while deleting record");
    }
  };

  return (
    <div className="management-request-wrapper animate-fade" style={{ padding: "20px" }}>

      {/* PENDING REQUESTS */}

      <div className="module-glass-card" style={{ marginBottom: "30px" }}>

        <h3 className="cyan-text">💰 REIMBURSEMENT_REQUESTS ({pending.length})</h3>

        {isMobile ? (

          <div className="reimbursement-mobile-list">

            {pending.map(req => (

              <div key={req.id} className="reimbursement-card">

                <h4>{req.employee_name}</h4>

                <p><strong>Category:</strong> {req.category}</p>

                <p><strong>Description:</strong> {req.item_name}</p>

                <p><strong>Amount:</strong> ₹ {req.amount}</p>

                <p><strong>Date:</strong> {req.expense_date}</p>

                <a
                  href={fileBaseUrl + req.receipt_file}
                  target="_blank"
                  rel="noreferrer"
                  className="table-action-btn view"
                >
                  VIEW RECEIPT
                </a>

                <div className="mobile-actions">

                  <button
                    className="mgnt-btn approve"
                    onClick={() => handleStatusUpdate(req.id, "Approved")}
                    style={{ backgroundColor: "#06aa14" }}
                  >
                    ✔ Approve
                  </button>

                  <button
                    className="mgnt-btn reject"
                    onClick={() => handleStatusUpdate(req.id, "Rejected")}
                    style={{ backgroundColor: "#f04343" }}
                  >
                    ✖ Reject
                  </button>

                </div>

              </div>

            ))}

          </div>

        ) : (

          <div className="admin-table-container reimbursement-table-wrapper">

            <table
              className="cyber-table reimbursement-table"
              style={{ tableLayout: "fixed", width: "100%" }}
            >

              <tr>

                <th style={{ width: '6%' }}>SR NO</th>
                <th style={{ width: '14%' }}>EMPLOYEE</th>
                <th style={{ width: '16%' }}>CATEGORY</th>
                <th style={{ width: '24%' }}>DESCRIPTION</th>
                <th style={{ width: '12%' }}>AMOUNT</th>
                <th style={{ width: '12%' }}>DATE</th>
                <th style={{ width: '10%' }}>RECEIPT</th>
                <th style={{ width: '12%' }}>ACTION</th>

              </tr>



              <tbody>

                {loading ? (
                  <tr>
                    <td colSpan="8">Loading requests...</td>
                  </tr>
                ) : pending.length > 0 ? (

                  pending.map((req, index) => (

                    <tr key={req.id} style={{ height: '72px' }}>
                      <td
                        style={{
                          padding: '12px',
                          textAlign: 'center',
                          verticalAlign: 'middle'
                        }}
                      >
                        {index + 1}
                      </td>

                      <td
                        style={{
                          padding: '12px',
                          verticalAlign: 'middle'
                        }}
                      >
                        {req.employee_name}
                      </td>

                      <td
                        style={{
                          padding: '12px',
                          verticalAlign: 'middle'
                        }}
                      >
                        {req.category}
                      </td>

                      <td
                        style={{
                          padding: '12px',
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          verticalAlign: 'middle'
                        }}
                      >
                        {req.item_name}
                      </td>

                      <td
                        style={{
                          padding: '12px',
                          verticalAlign: 'middle'
                        }}
                      >
                        ₹ {req.amount}
                      </td>

                      <td
                        style={{
                          padding: '12px',
                          verticalAlign: 'middle'
                        }}
                      >
                        {req.expense_date}
                      </td>

                      <td
                        style={{
                          padding: '12px',
                          textAlign: 'center',
                          verticalAlign: 'middle'
                        }}
                      >
                        <a
                          href={fileBaseUrl + req.receipt_file}
                          target="_blank"
                          rel="noreferrer"
                          className="table-action-btn view"
                        >
                          VIEW
                        </a>
                      </td>

                      <td
                        style={{
                          padding: '12px',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        <button
                          className="mgnt-btn approve"
                          onClick={() => handleStatusUpdate(req.id, "Approved")}
                          style={{
                            marginRight: '8px',
                            backgroundColor: '#06aa14',
                            position: 'relative',
                            top: '-5px'

                          }}
                        >
                          ✔
                        </button>

                        <button
                          className="mgnt-btn reject"
                          onClick={() => handleStatusUpdate(req.id, "Rejected")}
                          style={{
                            backgroundColor: '#f04343',
                            position: 'relative',
                            top: '-5px'
                          }}
                        >
                          ✖
                        </button>
                      </td>

                    </tr>

                  ))

                ) : (

                  <tr>
                    <td colSpan="8">NO_PENDING_REQUESTS</td>
                  </tr>

                )}

              </tbody>

            </table>

          </div>

        )}

      </div>

      {/* HISTORY */}

      <div className="module-glass-card history-card" style={{ opacity: 0.9 }}>

        <h3 style={{ color: "#888" }}>📜 PROCESSED_HISTORY ({history.length})</h3>

        {isMobile ? (

          <div className="reimbursement-mobile-list">

            {history.map(req => (

              <div key={req.id} className="reimbursement-card">

                <h4>{req.employee_name}</h4>

                <p><strong>Category:</strong> {req.category}</p>

                <p><strong>Amount:</strong> ₹ {req.amount}</p>

                <p><strong>Date:</strong> {req.expense_date}</p>

                <p>
                  <strong>Status:</strong>

                  <span
                    className={`status-text-${req.status?.toLowerCase()}`}
                  >
                    {req.status?.toUpperCase()}
                  </span>
                </p>

                {req.receipt_file && (
                  <a
                    href={fileBaseUrl + req.receipt_file}
                    target="_blank"
                    rel="noreferrer"
                    className="table-action-btn view"
                  >
                    VIEW RECEIPT
                  </a>
                )}

              </div>

            ))}

          </div>

        ) : (

          <div className="admin-table-container">

            <table className="cyber-table">




              <thead style={{ background: "#111827", borderBottom: "1px solid #374151" }}>


                <tr>

                  <th
                    style={{
                      padding: "12px",
                      width: "6%",
                      color: "#9ca3af",
                      textAlign: "center",
                      fontSize: "13px"
                    }}
                  >
                    SR NO
                  </th>
                  <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
                    EMPLOYEE
                  </th>

                  <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
                    CATEGORY
                  </th>

                  <th style={{ padding: "12px", width: "13%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
                    AMOUNT
                  </th>

                  <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
                    DATE
                  </th>

                  <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
                    RECEIPT
                  </th>

                  <th style={{ padding: "12px", width: "15%", color: "#9ca3af", textAlign: "left", fontSize: "13px" }}>
                    STATUS
                  </th>
                  <th
                    style={{
                      padding: "12px",
                      width: "12%",
                      color: "#9ca3af",
                      textAlign: "center",
                      fontSize: "13px"

                    }}
                  >
                    DELETE
                  </th>
                </tr>
              </thead>
              <tbody>

                {history.length > 0 ? (

                  history.map((req, index) => (
                    <tr key={req.id}>

                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px"
                        }}
                      >
                        {index + 1}
                      </td>

                      <td>{req.employee_name}</td>

                      <td
                        style={{
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          maxWidth: "220px",
                          padding: "12px"
                        }}
                      >
                        {req.category}
                      </td>

                      <td>₹ {req.amount}</td>

                      <td style={{ width: "15%", padding: "12px" }}>
                        {req.expense_date}
                      </td>


                      {/* ✅ ADD THIS BLOCK */}
                      <td style={{ width: "15%", padding: "12px" }}>
                        {req.receipt_file ? (
                          <a
                            href={fileBaseUrl + req.receipt_file}
                            target="_blank"
                            rel="noreferrer"
                            className="table-action-btn view"
                          >
                            VIEW
                          </a>
                        ) : (
                          "No File"
                        )}
                      </td>

                      <td>
                        <span
                          className={`status-text-${req.status?.toLowerCase()}`}
                          style={{ fontWeight: "bold" }}
                        >
                          {req.status?.toUpperCase()}
                        </span>
                      </td>

                      <td style={{ textAlign: "center" }}>
                        <button
                          className="mgnt-btn reject"
                          onClick={() => handleDelete(req.id)}
                          style={{
                            backgroundColor: "#ef4444",
                            color: "#fff",
                            border: "none",
                            cursor: "pointer",
                            position: "relative",
                            top: "-15px"

                          }}
                        >
                          🗑
                        </button>
                      </td>

                    </tr>
                  ))

                ) : (

                  <tr>
                    <td colSpan="8">NO_HISTORY_FOUND</td>
                  </tr>

                )}

              </tbody>

            </table>

          </div>

        )}

      </div>

    </div>
  );
};

export default ReimbursementManagement;